import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import styles from './ArticleSubtitle.module.css';
import PropTypes from 'prop-types';

const ArticleSubtitle = ({ children }) => {
  const { articleSubtitle } = useSearchParamOrDefaultProps();

  return (
    <article className={styles.articleSubtitleWrapper}>
      <div className={styles.articleSubtitle}>
        {children ? children : articleSubtitle}
      </div>
    </article>
  );
};

ArticleSubtitle.displayName = 'ArticleSubtitle';

ArticleSubtitle.defaultProps = {
  children: null,
};

ArticleSubtitle.propTypes = {
  children: PropTypes.node,
};

export default ArticleSubtitle;
